import _cloneDeep from 'lodash/cloneDeep';
import {isForestLawnPageType, useLegacyMenus} from './personPageType';
import forestLawnHeaderData from '../../App/data/forestLawnHeader.json';
import forestLawnFooterData from '../../App/data/forestLawnFooter.json';

/** Get the Header data for Funeral Home branded person
 * @param   {string}    pageType person page type key
 * @param   {number}    fhId funeral home id
 * @returns {Object} Menu data
 */
export function getFuneralHomeHeaderData(pageType, fhId) {
  if (isForestLawnPageType(pageType)) {
    let key = null;

    try {
      key = fhId.toString();
    } catch (err) {
      key = 'default';
    }
    return forestLawnHeaderData[key] || forestLawnHeaderData.default;
  }
  return {};
}

/** Get the Footer data for Funeral Home branded person
 * @param   {string}    pageType person page type key
 * @param   {number}    fhId funeral home id
 * @returns {Object} Footer data
 */
export function getFuneralHomeFooterData(pageType, fhId) {
  if (isForestLawnPageType(pageType)) {
    let key = null;

    try {
      key = fhId.toString();
    } catch (err) {
      key = 'default';
    }
    return forestLawnFooterData[key] || forestLawnFooterData.default;
  }
  return {};
}

/** Get the Header data for the given person page type key
 * @param   {string}    pageType person page type key
 * @param   {Object}    legacyHeader the legacy standard header
 * @param   {number}    fhId funeral home id
 * @returns {Object} header data
 */
export function getHeaderData(pageType, legacyHeader, fhId) {
  if (useLegacyMenus(pageType)) {
    return legacyHeader;
  }
  return getFuneralHomeHeaderData(pageType, fhId);
}

/** Get the Footer data for the given person page type key
 * @param   {string}    pageType person page type key
 * @param   {Object}    legacyFooter the legacy standard footer
 * @param   {Object}    legacySubFooter the legacy standard subfooter
 * @param   {number}    fhId funeral home id
 * @returns {Object} footer data
 */
export function getFooterData(pageType, legacyFooter, legacySubFooter, fhId) {
  if (useLegacyMenus(pageType)) {
    return {
      Menu: legacyFooter,
      SubMenu: legacySubFooter,
    };
  }
  return getFuneralHomeFooterData(pageType, fhId);
}

/** Removes any disabled links from Header/Footer input data
 * @param   {Object}    data header/footer data
 * @param   {String}    linkKey link attr to test
 * @param   {String}    linkValue link attr value to test
 * @param   {Boolean}   disable disable flag
 * @returns {Object}    updated header data
 */
export function overrideMenuOptions(data, linkKey, linkValue, disable) {
  if (!disable) {
    return data;
  }

  const menuData = _cloneDeep(data || {});
  const {data: {menu: links = []} = {}} = menuData;

  for (let i = links.length - 1; i >= 0; --i) {
    if (links[i][linkKey] === linkValue) {
      links.splice(i, 1);
    }
  }
  return menuData;
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/menuHelpers.js